<template>
  <div class="wzc_select" :style="styleVar">
    <div class="divSelect" :class="{ 'drop_down': isListShow }" ref="divSelect">
      <div class="divSelectinput" :style="{border: isListShow ? '.05rem solid #FFDB89' : '.05rem solid transparent'}">
        <!-- 选中后的内容 -->
        <div class="selectinfos" @click="dropDownSelect" v-if="id != 3" :title="label" :class="{ 'no_select': label == `${typeName}` }">
          {{ label }}
        </div>
        <div v-else class="selectinfos">
          <input 
            @click="dropDownSelect"
            @focus="inputFocus"
            @input="$emit('selectshow',id)"
            @blur="inputBlur"
            type="text"
            ref="input"
            :placeholder="typeName"
            v-model="inputValue">
        </div>
        <img :src="require(`@/assets/image/set/${isListShow ? 'uparrow' : 'down'}.png`)" class="img">
      </div>
    </div>
    <!-- 下拉框列表 -->
    <transition name="drop-down">
      <div class="Selectlist" v-show="isListShow" ref="dropDown">
        <ul class="wzc_option_list">
          <slot name="wzc_option"></slot>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'wzc_select',
  props: {
    typeName:{
      type: String,
      default: '游戏'
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    width: {
      type: Number,
      default: 180
    },
    height: {
      type: Number,
      default: 40
    },
    id:{
      type: String,
      default: ''
    },
    isshow:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      label: '',
      isListShow: false,
      optionid: '',
      inputValue: '',
      timer: null
    };
  },
  created() {
    if(this.id!=3) this.label = this.typeName;
  },
  computed: {
    styleVar() {
      return {
        '--select-height': this.height + 'px',
        '--select-width': this.width + 'px'
      }
    }
  },
  methods: {
    inputFocus(){
      this.$emit('filinput','',this.label != this.typeName ? this.label : '')
    },
    deleteValue(){
      this.inputValue = ''
    },
    inputBlur(){
      this.timer = setTimeout(()=>{
        if(this.inputValue != this.label){
          if(this.label == this.typeName){
            this.inputValue = ''
            this.$emit('filinput','')
          }else{
            this.inputValue = this.label
          }
        }
        this.$emit('selectshow','')
      },300)
    },
    selectdis(){
      this.isListShow = false;
    },
    datanone(){
      this.label = this.typeName;
    },
    dropDownSelect() {
      if(this.timer){
        clearTimeout(this.timer)
      }
      if(!this.isListShow){
        this.$emit('selectshow',this.id)
      }else{
        this.$emit('selectshow','')
      }
    }
  },
  watch:{
    inputValue(val){
      if(val){
        this.$emit('filinput',this.inputValue)
      }
    },
    label(val){
      if(val != this.typeName){
        this.inputValue = val
      }
      this.$emit('selectshow','')
    },
    isshow(val){
      this.isListShow = val
    }
  }
};
</script>

<style lang="scss" scoped>
.wzc_select {
  border-radius: .25rem;
  height: var(--select-height);
  line-height: var(--select-height);
}

.divSelect {
  width: 100%;
  height: 1.8rem;
  background: #F2F2F2;
  border-radius: .2rem;
}

.drop_down {
  background: #FFFFFF;
}

.divSelectinput {
  height: 100%;
  padding: 0 .5rem;
  display: flex;
  align-items: center;
  .selectinfos {
    flex: 1;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    input{
			border: none;
      font-size: .7rem;
			background: transparent;
      &::placeholder{
        color: #8E8E8E;
      }
    }
  }
  .img {
    display: block;
    width: .7rem;
    height: .7rem;
  }
}

.no_select {
  color: #8E8E8E;
}

.Selectlist {
  z-index: 800;
  position: relative;
  background-color: #fff;
  border: .05rem solid #FFDB89;
}

.wzc_option_list {
  width: 100%;
  max-height: 9.25rem;
  padding: 0;
  background: #FFFFFF;
  box-shadow: 0 .15rem .15rem .05rem rgba(0, 0, 0, 0.1);
  border-radius: .2rem;
  overflow-y: scroll;
}

.drop-down-enter {
  opacity: 0;
  transform: translate(0rem, -4rem) scaleY(0.2);
}

.drop-down-leave-to {
  opacity: 0;
  transform: translate(0rem, -4rem) scaleY(0.2);
}
</style>